<template>
  <div class="cohort-data-selector">
    <div>
      <h3>Programme</h3>
      <sui-module-selector
            :targets="sc.programs"
            :locked="locked"
            @selected="selectProgram">
      </sui-module-selector>
    </div>
    <div v-if="program">
      <h3>Modules</h3>
      <sui-module-selector
             :targets="program.modules"
             :multi="program.modules.length > 1"
             :locked="locked"
             @selected="selectModules">
      </sui-module-selector>
    </div>
    <div v-if="modules">
      <h3>Jeux de données de référence</h3>
      <sui-dataset-selector :locked="locked"
                            :availableDatasetsByYear="dsetByYear"
                            @selected="selectDatasets">
      </sui-dataset-selector>
    </div>
  </div>
</template>
<script>

import suiModuleSelector from '@/sui/components/module/selector'
import suiDatasetSelector from '@/sui/components/dataset/selector'

const years = [
  '2020', '2021', '2022', '2023', '2024', '2025', '2026'
]

const sc = {
  programs: [
    {
      name: 'Surveillance',
      style: 'results',
      observation: false,
      years: years,
      modules: [
        { name: 'Bact ADI+', style: 'bactADI' },
        { name: 'Exp ADI', style: 'expADI' },
        { name: 'Réa Inf ADI', style: 'reaInfADI' },
        { name: 'Néo Inf ADI', style: 'neoInfADI' },
        { name: 'Dia Inf ADI', style: 'diaInfADI' }
      ]
    }
  ]
}

export default {
  name: 'cohort-data-selector',

  props: {
    availableDatasetsByYear: {
      type: Object,
      default: () => {}
    },

    locked: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      sc: sc,

      program: null,
      modules: null,
      datasets: null
    }
  },

  methods: {

    selectProgram: function (p) {
      this.program = p
      if (this.program.defaultModules != null) {
        const vm = this
        this.$nextTick(() => vm.selectModules(this.program.defaultModules))
      }
    },

    selectModules: function (m) {
      this.modules = m
      this.modulesLocked = true
    },

    selectDatasets: function (d) {
      this.datasets = d
      this.$emit(
        'selected', {
          program: this.program,
          mods: this.modules,
          dsets: this.datasets
        }
      )
    }
  },

  computed: {
    dsetByYear: function () {
      if (this.program == null || this.modules == null) {
        return null
      }

      const reference = this.program.observation
        ? this.availableDatasetsByYear.obs
        : this.availableDatasetsByYear.surv
      const result = {}
      for (let i = 0; i !== this.program.years.length; ++i) {
        const y = this.program.years[i]
        const r = reference[y]
        if (r != null) {
          result[y] = r
        }
      }
      return result
    }
  },

  components: {
    'sui-dataset-selector': suiDatasetSelector,
    'sui-module-selector': suiModuleSelector
  }
}
</script>
<style scoped lang="less">

</style>
